<template>
    <div class="sign-rule">
        <div class="wechat-rule" v-if="isWechart">
            <div v-if="!iosClent">
                <div class="title">
                    一、每日签到
                </div>
                <div class="message">
                    1.用户每日可参与签到领取积分，观看完整视频广告后可获得双倍积分。<br />
                    2.连续签到以7天为一个周期，每周一到周三签到积分为5积分/天，周四到周日为8积分/天。<br />
                    3.签到每天0点刷新，断签可在当前页面点击补签，购买1票可完成当日补签。<br />
                    4.每个用户仅限使用一个账号参与签到（小程序、IOS、安卓APP均视为一个账号）。<br />
                </div>
                <div class="title">
                    二、各种活动
                </div>
                <div class="message">
                    我们会不定期推出各种活动，参加活动可以获得海量积分，以及更多其他奖励。
                </div>
                <div class="title">
                    三、做任务，赢奖励
                </div>
                <div class="message">
                    1.用户每日可通过参与任务版块、活动板块获得额外积分奖励。<br />
                    2.每日任务每次完成都可以领取相应的积分；一次性任务只能领取一次奖励，在完成后消失。<br />
                    3.下载APP后，10票立即到账，您可以直接在APP上使用，不需要返回小程序领取（同一手机号、同一手机设备仅限领取一次）。<br />
                    4.邀请好友任务：被邀请的好友只需要完成注册，邀请人即可领取奖励。<br />
                    5.连续签到任务以及累计签到任务完成后，第二天重置，可以重复完成。<br />
                    6.助力任务、每日首次定位以及观看视频任务每日零点刷新次数，若前一日积分未领取，默认为积分过期；其他任务积分自任务完成后一周内若未领取，则默认为过期。<br />
                </div>
            </div>
            <div v-else>
                <div class="title">
                    一、每日签到
                </div>
                <div class="message">
                    1.用户每日可参与签到领取积分，观看完整视频广告后可获得双倍积分。<br />
                    2.连续签到以7天为一个周期，每周一到周三签到积分为5积分/天，周四到周日为8积分/天，签到每天0点刷新。<br />
                    3.每个用户仅限使用一个账号参与签到（小程序、IOS、安卓APP均视为一个账号）。<br />
                </div>
                <div class="title">
                    二、各种活动
                </div>
                <div class="message">
                    我们会不定期推出各种活动，参加活动可以获得海量积分，以及更多其他奖励。
                </div>
                <div class="title">
                    三、做任务，赢奖励
                </div>
                <div class="message">
                    1.用户每日可通过参与任务版块、活动板块获得额外积分奖励。<br />
                    2.每日任务每次完成都可以领取相应的积分；一次性任务只能领取一次奖励，在完成后消失。<br />
                    3.下载APP后，10票立即到账，您可以直接在APP上使用，不需要返回小程序领取（同一手机号、同一手机设备仅限领取一次）。<br />
                    4.邀请好友任务：被邀请的好友只需要完成注册，邀请人即可领取奖励。<br />
                    5.连续签到任务以及累计签到任务完成后，第二天重置，可以重复完成。<br />
                    6.助力任务、每日首次定位以及观看视频任务每日零点刷新次数，若前一日积分未领取，默认为积分过期；其他任务积分自任务完成后一周内若未领取，则默认为过期。<br />
                </div>
            </div>
        </div>
        <div class="client" v-else>
            <div class="title">
                一、每日签到
            </div>
            <div class="message">
                1.用户每日可参与签到领取积分，观看完整视频广告后可获得双倍积分。<br />
                2.连续签到以7天为一个周期，每周一到周三签到积分为5积分/天，周四到周日为8积分/天。<br />
                3.签到每天0点刷新，断签可在当前页面点击补签，购买1票可完成当日补签。<br />
                4.每个用户仅限使用一个账号参与签到（小程序、IOS、安卓APP均视为一个账号）。<br />
            </div>
            <div class="title">
                二、各种活动
            </div>
            <div class="message">
                我们会不定期推出各种活动，参加活动可以获得海量积分，以及更多其他奖励。
            </div>
            <div class="title">
                三、做任务，赢奖励
            </div>
            <div class="message">
                1.用户每日可通过参与任务版块、活动板块获得额外积分奖励。<br />
                2.APP用户每月可以在任务栏领取APP专属的5票免费票。<br />
                3.每日任务每次完成都可以领取相应的积分；一次性任务只能领取一次奖励，在完成后消失。<br />
                4.连续签到任务以及累计签到任务完成后，第二天重置，可以重复完成。<br />
                5.助力任务、每日首次定位以及观看视频任务每日零点刷新次数，若前一日积分未领取，默认为积分过期；其他任务积分自任务完成后一周内若未领取，则默认为过期。<br />
            </div>
        </div>
        <div class="careful">
            注：积分可以用于积分商城兑换对应商品且一年有效，如果在年底（12月31日）未使用完毕则来年（1月1日）清空积分。
        </div>
        <footer class="footer">
            所有活动最终解释权归苏州海管家物流科技有限公司所有
        </footer>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            iosClent: !!navigator.userAgent.match(
                /\(i[^;]+;( U;)? CPU.+Mac OS X/
            )
        }
    },
    computed: {},
    components: {},
    created() {},
    mounted() {
    },
    watch: {},
    methods: {}
}
</script>

<style scoped lang="scss">
.sign-rule {
    height: 100vh;
    background-color: #f2f2f2;
    padding: 30px;
    font-size: 24px;
    color: #282828;
    .title {
        font-size: 28rpx;
        font-weight: bold;
    }
    .message {
        padding: 10px 0 30px;
    }
    .careful {
        padding: 10px 0 20px;
    }
    .footer {
        font-size: 20px;
        text-align: center;
        color: #707070;
    }
}
</style>
